import styled from "styled-components";

export const TabsNavigationWapperDefaultBox = styled.div<{className?: string;}>`
    display: flex;
    gap: 8px;

    padding-block: 8px 3px;
    width: max-content;
`;
